import api from '@/config/api'
import {
   AuthUser,
   LoginRequest,
   LoginResponse,
   ChangePasswordRequest,
   InvitationInfo,
} from '@/types';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5004/api';

export interface LoginCredentials {
   email: string;
   password?: string;
   invitationToken?: string;
}

export const authService = {
   // Admin login (regular or invitation-based)
   async login(credentials: LoginRequest): Promise<LoginResponse> {
      const response = await api.post(`${API_URL}/auth/login`, credentials);
      const { token, customToken, user } = response.data.data;

      // Store token in localStorage
      localStorage.setItem('authToken', token);

      return { token, customToken, user };
   },

   // Change password after first login or regular password change
   async changePassword(data: ChangePasswordRequest): Promise<void> {
      await api.post(`${API_URL}/auth/change-password`, data);
   },

   // Verify invitation token
   async verifyInvitation(token: string): Promise<InvitationInfo> {
      const response = await api.get(`${API_URL}/auth/verify-invitation/${token}`);
      return response.data.data;
   },

   // Get current user profile
   async getCurrentUser(): Promise<AuthUser> {
      const response = await api.get(`${API_URL}/auth/profile`);
      return response.data.data;
   },

   // Logout user
   async logout(): Promise<void> {
      try {
         await api.post(`${API_URL}/auth/logout`);
      } catch (error) {
         console.warn('Logout API call failed:', error);
      } finally {
         // Always remove token from localStorage
         localStorage.removeItem('authToken');
      }
   },

   // Verify if user is authenticated
   isAuthenticated(): boolean {
      return !!localStorage.getItem('authToken');
   },

   // Get stored token
   getToken(): string | null {
      return localStorage.getItem('authToken');
   },

   // Clear stored token
   clearToken(): void {
      localStorage.removeItem('authToken');
   },

   // Parse invitation token from URL
   parseInvitationFromUrl(): string | null {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('invitation');
   },
}; 